import { createSlice } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

// /Quadrant/Front-End-Riemann/webapp/src/components/Map/layers/LayersApi.js
// /Quadrant/Front-End-Riemann/webapp/src/store/global/map/layersInfo.js

// import LayersApi from '../../../components/Map/layers/LayersApi'
// import { setDeckglLayersInfo } from 'store/global/map/deckglLayersInfo'

// const dispatch = useDispatch()

const initialState = {
  data: [],
}

const layersInfoSlice = createSlice({
  name: 'layersInfoSlice',
  initialState,
  reducers: {
    appendLayersInfo(state, action) {
      state.data = [...state.data, action.payload]
    },
    appendLayersInfoMapboxLayers(state, action) {
      state.data = [...state.data, ...action.payload]
    },
    setLayersInfo(state, action) {
      state.data = [...action.payload]

      // let processLayers = LayersApi(state.data)
      // dispatch(
      //   setDeckglLayersInfo(processLayers)
      // )
    },
  },
})

export const { setLayersInfo, appendLayersInfo, appendLayersInfoMapboxLayers } = layersInfoSlice.actions

export default layersInfoSlice.reducer
